import { useNavigate } from 'react-router-dom';
import { useEffect } from 'react';

interface allProps {
  isLocked: boolean;
  isCompleted: boolean;
  setSelectedTask: Function;
  taskDetail: any;
  setCount: Function;
  superCapstoneId: any;
  taskNo: number;
  openTask2FeedbackPopup: (taskDetail: any) => void;
  isTask2FeedbackSubmitted: boolean;
}

const Task = (props: allProps) => {
  const taskDetail = props.taskDetail;
  const navigate = useNavigate();
  const { taskNo, isCompleted, isLocked, openTask2FeedbackPopup, isTask2FeedbackSubmitted } = props;

  useEffect(() => {
    if (
      taskNo === 2 &&
      isCompleted &&
      !isLocked &&
      !isTask2FeedbackSubmitted
    ) {
      openTask2FeedbackPopup(taskDetail);
    }
  }, [
    isCompleted,
    taskNo,
    isLocked,
    openTask2FeedbackPopup,
    taskDetail,
    isTask2FeedbackSubmitted,
  ]);

  return (
    <tr
      onClick={() => {
        if (!props.isLocked) {
          props.setSelectedTask(taskDetail);
          props.setCount();
          navigate(
            `/supercapstone/${
              props.superCapstoneId
            }/${taskDetail.taskNo.toString()}`
          );
        }
      }}
      className={`border-b border-slate-300 items-center font-medium 
        ${
          props.isLocked
            ? 'cursor-not-allowed text-gray-500'
            : 'cursor-pointer hover:bg-gray-50'
        } 
        ${props.isLocked && 'pointer-events-none'}`}>
      <td
        className={`border-l border-slate-300 md:px-4 py-2 ${
          props.isLocked ? 'text-gray-400' : ''
        }`}>
        {taskDetail.title}
      </td>
      <td
        className={`border-l border-r border-slate-300 md:px-4 text-center py-2 ${
          props.isLocked ? 'text-gray-400' : ''
        }`}>
        {taskDetail.time}
      </td>
      <td
        className={` flex flex-wrap gap-2 lg:gap-4 items-center  md:px-4 py-3 ${
          props.isLocked ? 'text-gray-400' : ''
        }`}>
        {taskDetail.skillId.map((skill: any) => skill.title).join(', ')}
      </td>
      <td className='border-l border-r border-slate-300 text-left md:px-6 py-2'>
        {!props.isLocked ? (
          !props.isCompleted ? (
            <p className='bg-yellow-200 w-fit py-1 px-3 rounded-full font-medium'>
              Ongoing
            </p>
          ) : (
            <div className='flex flex-col space-y-1 items-start'>
              <p className='bg-green-200 w-fit py-1 px-3 rounded-full font-medium'>
                Completed
              </p>
            </div>
          )
        ) : (
          <p className='bg-red-200 w-fit py-1 px-3 rounded-full font-medium'>
            Locked
          </p>
        )}
      </td>
    </tr>
  );
};

export default Task;
